<template>
  <svg>
    <!-- 轮廓线 -->
    <g v-for="item of polygonsArray" :key="item.adcode">
      <polygon
        :class="{
          mapDefaultStyle: item.adcode !== activeAreaPropertie.adcode,
          mapActiveStyle: item.adcode === activeAreaPropertie.adcode
        }"
        v-for="polygon of item.polygons"
        :points="polygon"
        :key="polygon"
        @mouseover="mapActive(item)"
        @mouseout="mapDefault()"
        @click="mapClick(item)"
      ></polygon>
    </g>
    <!-- 地图填充图 -->
    <g>
      <defs>
        <mask id="base_map_mask">
          <g v-for="item of polygonsArray" :key="item.adcode">
            <polygon
              fill="white"
              v-for="polygon of item.polygons"
              :points="polygon"
              :key="polygon"
            ></polygon>
          </g>
        </mask>
      </defs>
      <foreignObject :width="'100%'" :height="'100%'" :class="{maskImage: mask}" style="pointer-events: none">
        <!-- <img :src="'../../assets/point.png'" :style="{width: imageSize.width, height: imageSize.height}"> -->
      </foreignObject>
    </g>
    <!-- 文字 -->
    <g>
      <text
        class="areaName"
        v-for="item of polygonsArray"
        :key="item.adcode"
        :x="item.geometryCenter[0]"
        :y="item.geometryCenter[1] + 15"
      >
        {{ item.name }}
      </text>
    </g>
  </svg>
</template>
<script>
export default {
  name: "BaseMap",
  props: ["polygonsArray", "width", "height", "mask", "drillDown"],
  data: function() {
    return {
      activeAreaPropertie: {},
      imageSize: {
        width: "0px",
        height: "0px"
      }
    };
  },
  methods: {
    // 鼠标悬停
    mapActive: function(propertie) {
      this.activeAreaPropertie = propertie;
      this.$parent.setActiveArea(propertie);
    },
    // 鼠标悬停移除
    mapDefault: function() {
      this.activeAreaPropertie = {};
      this.$parent.setActiveArea(undefined);
    },
    // 地图点击
    mapClick: function(propertie) {
      if(!this.drillDown) {
        return
      }
      this.$parent.setActiveArea(undefined);
      this.$parent.getData(propertie);
    },
    // 根据图片大小高度或者宽度铺满
    initBackgrounImage() {
      let image = new Image();
      image.src = "../../assets/point.png";
      image.onload = () => {
        const imageRatio = image.width / image.height;
        const containerRatio = this.width / this.height;

        const imageWidth =
            imageRatio > containerRatio ? imageRatio * this.width : this.width,
          imageHeight =
            imageRatio > containerRatio
              ? this.height
              : this.height / imageRatio;
        this.imageSize.width = imageWidth + "px";
        this.imageSize.height = imageHeight + "px";
      };
    }
  },
  mounted: function() {
    //this.initBackgrounImage();
  }
};
</script>
<style scoped>
svg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.mapDefaultStyle {
  stroke: #cbeeff;
  stroke-width: 1.5;
  fill: #033281;
}

.mapActiveStyle {
  stroke: #cbeeff;
  stroke-width: 3;
  fill: rgb(44, 128, 197);
}

.maskImage {
  mask: url(#base_map_mask);
  background: url(../../assets/point.png);
  opacity: 0.4;
}

.areaName {
  pointer-events: none;
  fill: #cbeeff;
  font-size: 0.14rem;
  font-weight: bold;
  font-family: "微软雅黑";
  text-anchor: middle;
}
</style>
